<template>
  <div class="shoppingCart">
    <div class="labelNav acea-row row-around row-middle">
      <div class="item">
        <span class="iconfont icon-xuanzhong"></span>100%正品保证
      </div>
      <div class="item">
        <span class="iconfont icon-xuanzhong"></span>所有商品精挑细选
      </div>
      <div class="item">
        <span class="iconfont icon-xuanzhong"></span>售后无忧
      </div>
    </div>
    <div class="nav acea-row row-between-wrapper">
      <div>
        购物数量 <span class="num font-color-red">{{ count }}</span>
      </div>
      <div v-if="valid.length > 0" class="administrate acea-row row-center-wrapper" @click="manage">
        {{ footerswitch ? '取消' : '管理' }}
      </div>
    </div>
    <div style="margin-top: 1.71rem;"></div>
    <div v-if="valid.length > 0 || invalid.length > 0">
      <div v-for="(item, index) in valid" :key="index" class="store">
        <div class="one">
          <div>
            <div class="iconfont icon-xinpin title">
              <span>{{ item.mer_name }}</span>
            </div>
          </div>
          <div class="list">
            <div class="item acea-row row-between-wrapper" v-for="(sub_item, sub_index) in item.product_list"
              :key="sub_index">
              <div class="select-btn">
                <div class="checkbox-wrapper">
                  <label class="well-check">
                    <input type="checkbox" name="" value="" :checked="sub_item.checked"
                      @click="switchSelect(index, sub_index)" />
                    <i class="icon"></i>
                  </label>
                </div>
              </div>
              <div class="picTxt acea-row row-between-wrapper">
                <div class="pictrue" @click="
                    $router.push({ path: '/detail/' + sub_item.product_id })
                  ">
                  <img :src="sub_item.productInfo.attrInfo.image" v-if="
                      sub_item.productInfo.attrInfo &&
                        sub_item.productInfo.attrInfo.image
                    " />
                  <img :src="sub_item.productInfo.image" v-else />
                </div>
                <div class="text">
                  <div class="line1">{{ sub_item.productInfo.store_name }}</div>
                  <div class="infor line1" v-if="sub_item.productInfo.attrInfo">
                    属性：{{ sub_item.productInfo.attrInfo.suk }}
                  </div>
                  <div class="money">￥{{ sub_item.truePrice }}</div>
                </div>
                <div class="carnum acea-row row-center-wrapper">
                  <div class="reduce" :class="sub_item.cart_num <= 1 ? 'on' : ''"
                    @click.prevent="reduce(index, sub_index)">
                    -
                  </div>
                  <div class="num">
                    <input type="tel" class="cart-item" v-model="sub_item.cart_num" @change="input(index, sub_index)" />
                  </div>

                  <div class="plus" v-if="sub_item.attrInfo" :class="
                      sub_item.cart_num >= sub_item.attrInfo.stock ? 'on' : ''
                    " @click.prevent="plus(index, sub_index)">
                    +
                  </div>
                  <div class="plus" v-else :class="sub_item.cart_num >= sub_item.stock ? 'on' : ''"
                    @click.prevent="plus(index, sub_index)">
                    +
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="invalidGoods" v-if="invalid.length > 0">
        <div class="goodsNav acea-row row-between-wrapper">
          <div @click="goodsOpen">
            <span class="iconfont" :class="goodsHidden === true ? 'icon-xiangyou' : 'icon-xiangxia'"></span>失效商品
          </div>
          <div class="del" @click="delInvalidGoods">
            <span class="iconfont icon-shanchu1"></span>清空
          </div>
        </div>
        <div v-for="(item, index) in invalid" :key="index">
          <div class="goodsList" :hidden="goodsHidden">
            <router-link :to="{ path: '/detail/' + sub_item.product_id }" class="item acea-row row-between-wrapper"
              v-for="(sub_item, sub_index) in item.product_list" :key="sub_index">
              <div class="invalid acea-row row-center-wrapper">失效</div>
              <div class="pictrue">
                <img v-if="sub_item.productInfo.attrInfo" :src="sub_item.productInfo.attrInfo.image" />
                <img :src="sub_item.productInfo.image" v-else />
              </div>
              <div class="text acea-row row-column-between">
                <div class="line1">{{ sub_item.productInfo.store_name }}</div>
                <div class="infor line1" v-if="sub_item.productInfo.attrInfo">
                  属性：{{ sub_item.productInfo.attrInfo.suk }}
                </div>
                <div class="acea-row row-between-wrapper">
                  <div class="end">该商品已下架</div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div> -->
    </div>
    <!--购物车暂无商品-->
    <div class="noCart" v-if="valid.length === 0 && invalid.length === 0">
      <div class="pictrue"><img src="@assets/images/noCart.png" /></div>
      <Recommend></Recommend>
    </div>
    <div style="height:2.1rem"></div>
    <div class="footer acea-row row-between-wrapper" v-if="valid.length > 0">
      <div>
        <div class="select-btn">
          <div class="checkbox-wrapper">
            <label class="well-check">
              <input type="checkbox" name="" value="" :checked="isAllSelect && cartCount > 0" @click="allChecked" />
              <i class="icon"></i>
              <span class="checkAll">全选 ({{ cartCount }})</span>
            </label>
          </div>
        </div>
      </div>
      <div class="money acea-row row-middle" v-if="footerswitch === false">
        <span class="font-color-red">￥{{ countmoney }}</span>
        <div class="placeOrder bg-color-red" @click="placeOrder">立即下单</div>
      </div>
      <div class="button acea-row row-middle" v-else>
        <div class="bnt cart-color" @click="collectAll">收藏</div>
        <div class="bnt" @click="delgoods">删除</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Recommend from '@components/Recommend';
  import {
    getCartList,
    postCartDel,
    changeCartNum,
    getCartCount,
  } from '@api/store';
  import {
    postCollectAll
  } from '@api/user';
  import {
    mul,
    add
  } from '@utils/bc';
  import cookie from '@utils/store/cookie';
  import debounce from 'lodash.debounce';

  const CHECKED_IDS = 'cart_checked';

  export default {
    name: 'ShoppingCart',
    components: {
      Recommend,
    },
    props: {},
    data: function () {
      return {
        cartList: {
          invalid: [],
          valid: []
        },
        valid: [],
        invalid: [],
        isAllSelect: false,
        cartCount: 0,
        countmoney: 0,
        goodsHidden: true,
        footerswitch: false,
        count: 0,
        checkedIds: [],
        loaded: false,
        product_list: 0,
      };
    },
    watch: {
      $route(n) {
        if (n.name === 'ShoppingCart') {
          this.carnum();
          this.countMoney();
          this.getCartList();
          this.gainCount();
          this.goodsHidden = true;
          this.footerswitch = false;
        }
      },
    },
    mounted: function () {
      let that = this;
      that.carnum();
      that.countMoney();
      that.getCartList();
      that.gainCount();
    },
    methods: {
      getCartList: function () {
        let that = this;
        that.product_list = 0;
        getCartList().then((res) => {
          console.log(res, 'res');
          that.invalid = res.data.invalid;
          that.valid = res.data.valid;
          let checkedIds = cookie.get(CHECKED_IDS) || [];
          if (!Array.isArray(checkedIds)) checkedIds = [];
          that.valid.forEach((cart) => {
            cart.product_list.forEach((item) => {
              if (checkedIds.indexOf(item.id) !== -1) item.checked = true;
              that.product_list++;
            });
          });

          if (checkedIds.length) {
            that.checkedIds = checkedIds;
            that.isAllSelect = checkedIds.length === that.product_list;
            that.carnum();
            that.countMoney();
          }
          that.loaded = true;
        });
      },
      //删除商品；
      delgoods: function () {
        let that = this,
          id = [],
          valid = [],
          list = that.valid;
        list.forEach(function (val) {
          val.product_list.forEach(function (item) {
            if (item.checked === true) {
              id.push(item.id);
            }
          });
        });
        if (id.length === 0) {
          that.$dialog.toast({
            mes: '请选择产品'
          });
          return;
        }
        postCartDel(id).then(function () {
          // console.log(list, 'list')
          // list.forEach(function (val, i) {
            
          //   val.product_list.forEach(function (item, j) {
          //     if (item.checked === false || item.checked === undefined)
          //       valid.push(list[i][j]);
          //   });
          // });
          // console.log(valid, 'valid')
          // that.$set(that.cartList, 'valid', valid);
          // that.valid = that.cartList.valid;
          // console.log(that.valid, 'that.valid')
          // that.carnum();
          // that.countMoney();
          // that.gainCount();
          that.getCartList()
          // that.carnum();
          // that.countMoney();
          that.gainCount();
        });
      },
      // //获取数量
      gainCount: function () {
        let that = this;
        getCartCount().then((res) => {
          that.count = res.data.count;
        });
      },
      //清除失效产品；
      delInvalidGoods: function () {
        let that = this,
          id = [],
          list = that.invalid;
        list.forEach(function (val) {
          id.push(val.id);
        });
        postCartDel(id).then(function () {
          list.splice(0, list.length);
          that.gainCount();
        });
      },
      //批量收藏;
      collectAll: function () {
        let that = this,
          data = {
            id: [],
            category: ''
          },
          list = that.valid;
        list.forEach(function (val) {
          val.product_list.forEach(function (item) {
            if (item.checked === true) {
              data.id.push(item.product_id);
              data.category = item.type;
            }
          });
        });
        if (data.id.length === 0) {
          that.$dialog.toast({
            mes: '请选择产品'
          });
          return;
        }
        postCollectAll(data).then(function () {
          that.$dialog.toast({
            mes: '收藏成功!'
          });
        });
      },
      //立即下单；
      placeOrder: function () {
        let that = this,
          list = that.valid,
          id = [];
        list.forEach(function (val) {
          val.product_list.forEach(function (s_val) {
            if (s_val.checked === true) {
              id.push(s_val.id);
            }
          });
        });
        if (id.length === 0) {
          that.$dialog.toast({
            mes: '请选择产品'
          });
          return;
        }
        this.$router.push({
          path: '/order/submit/' + id
        });
      },
      manage: function () {
        let that = this;
        that.footerswitch = !that.footerswitch;
      },
      goodsOpen: function () {
        let that = this;
        that.goodsHidden = !that.goodsHidden;
      },
      //加
      plus: function (index, sub_index) {
        let that = this;
        let list = that.valid[index].product_list[sub_index];
        list.cart_num++;
        if (list.attrInfo) {
          if (list.cart_num >= list.attrInfo.stock) {
            that.$set(list, 'cart_num', list.attrInfo.stock);
          }
        } else {
          if (list.cart_num >= list.stock) {
            that.$set(list, 'cart_num', list.stock);
          }
        }
        that.carnum();
        that.countMoney();
        that.syncCartNum(list);
      },
      //减
      reduce: function (index, sub_index) {
        let that = this;
        let list = that.valid[index].product_list[sub_index];
        list.cart_num--;
        if (list.cart_num < list.productInfo.mininum) {
          this.$dialog.error('此商品的最低购买数量为' + list.productInfo.mininum);
          that.$set(list, 'cart_num', list.productInfo.mininum);
        }
        that.carnum();
        that.countMoney();
        that.syncCartNum(list);
      },
      syncCartNum(cart) {
        if (!cart.sync)
          cart.sync = debounce(() => {
            changeCartNum(cart.id, Math.max(cart.cart_num, 1) || 1);
          }, 500);

        cart.sync();
      },
      // 输入数量
      input: function (index, sub_index) {
        let that = this;
        let list = that.valid[index].product_list[sub_index];
        if (isNaN(list.cart_num)) {
          this.$dialog.error('此商品的最低购买数量为' + list.productInfo.mininum);
          that.$set(list, 'cart_num', list.productInfo.mininum);
        }
        if (list.cart_num < list.productInfo.mininum) {
          this.$dialog.error('此商品的最低购买数量为' + list.productInfo.mininum);
          that.$set(list, 'cart_num', list.productInfo.mininum);
        }
        list.cart_num;
        that.carnum();
        that.countMoney();
        that.syncCartNum(list);
      },
      syncCartNum(cart) {
        if (!cart.sync)
          cart.sync = debounce(() => {
            changeCartNum(cart.id, Math.max(cart.cart_num, 1) || 1);
          }, 500);

        cart.sync();
      },
      //单选
      switchSelect: function (index, sub_index) {
        let that = this,
          cart = that.valid[index].product_list[sub_index],
          i = this.checkedIds.indexOf(cart.id);
        cart.checked = !cart.checked;

        if (i !== -1) this.checkedIds.splice(i, 1);
        if (cart.checked) {
          this.checkedIds.push(cart.id);
        }
        let len = that.valid.length;
        var p_en = 0;
        let selectnum = [];
        for (let i = 0; i < len; i++) {
          p_en += that.valid[i].product_list.length;
          for (let j = 0; j < that.valid[i].product_list.length; j++) {
            if (that.valid[i].product_list[j].checked === true) {
              selectnum.push(true);
            }
          }
        }
        that.isAllSelect = selectnum.length === p_en;
        that.$set(that, 'cartList', that.cartList);
        that.$set(that, 'isAllSelect', that.isAllSelect);
        cookie.set(CHECKED_IDS, that.checkedIds);
        that.carnum();
        that.countMoney();
      },
      //全选
      allChecked: function () {
        let that = this;
        let selectAllStatus = that.isAllSelect;
        selectAllStatus = !selectAllStatus;
        let checkedIds = [];
        that.valid.forEach((cart) => {
          cart.product_list.forEach((item) => {
            item.checked = selectAllStatus;
            if (selectAllStatus) checkedIds.push(item.id);
          });
        });
        that.$set(that, 'cartList', that.cartList);
        that.$set(that, 'isAllSelect', selectAllStatus);
        this.checkedIds = checkedIds;
        cookie.set(CHECKED_IDS, checkedIds);
        that.carnum();
        that.countMoney();
      },
      //数量
      carnum: function () {
        let that = this;
        var carnum = 0;
        var array = that.valid;
        for (let i = 0; i < array.length; i++) {
          let list = array[i].product_list;
          for (let j = 0; j < list.length; j++) {
            if (list[j].checked === true) {
              carnum += parseInt(list[j].cart_num);
            }
          }
        }
        that.$set(that, 'cartCount', carnum);
      },
      //总共价钱；
      countMoney: function () {
        let that = this;
        let carmoney = 0;
        let array = that.valid;
        for (let i = 0; i < array.length; i++) {
          let list = array[i].product_list;
          for (let j = 0; j < list.length; j++) {
            if (list[j].checked === true) {
              carmoney = add(carmoney, mul(list[j].cart_num, list[j].truePrice));
            }
          }
        }
        that.countmoney = carmoney;
      },
    },
  };
</script>
<style scoped>
  .shoppingCart .list .item .picTxt .carnum .num {
    width: 1.1rem;
  }

  input.cart-item {
    width: 100%;
    text-align: center;
  }

  .shoppingCart .list .item .picTxt .carnum div {
    width: 0.5rem;
  }
</style>
